import { FunctionComponent } from 'react';
import { Box, Button } from '@rsos/components/capstone/base';

interface TrainingBtnProps {
  handleSAMLRequest: (service: string) => void;
  isLoadingSAML: boolean;
}

export const TrainingBtn: FunctionComponent<TrainingBtnProps> = ({
  handleSAMLRequest,
}) => {
  return (
    <Box horizontal onClick={() => handleSAMLRequest('training')}>
      <Button btnType="tertiary" size="small" type="submit">
        Training
      </Button>
    </Box>
  );
};

export default TrainingBtn;
